import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import Combobox from "@ls/react-combobox-grid";
import PivotFADefinition from "state/pivots/PivotFADefinition";
import { useSelector } from "react-redux";
import {
  selectFactribPeriods,
  selectFactribTypes,
  selectFetchingFactribPeriods,
  selectFetchingFactribTypes,
} from "state/factrib/selectors";

const MiniFaSelectorComplication = ({ setNewFa, faDefinition }) => {
  const { factribFactor, factribPeriod } = faDefinition;
  const fetchingFactribTypes = useSelector(selectFetchingFactribTypes);
  const factribTypes = useSelector(selectFactribTypes);
  const fetchingFactribPeriods = useSelector(selectFetchingFactribPeriods);
  const factribPeriods = useSelector(selectFactribPeriods);

  const factribTypeOptions = useMemo(
    () => factribTypes.map((val) => ({ label: val, value: val })),
    [factribTypes]
  );
  const factribPeriodOptions = useMemo(
    () => factribPeriods.map((val) => ({ label: val, value: val })),
    [factribPeriods]
  );

  return (
    <div className={styles.root}>
      <div className={styles.selector}>
        <Combobox
          label="Factor:"
          labelPosition={"TOP"}
          loading={fetchingFactribTypes}
          value={factribFactor}
          options={factribTypeOptions}
          placeholder="Select factor..."
          onChange={(factribFactor) =>
            setNewFa(
              new PivotFADefinition({
                factribFactor,
                factribPeriod,
              })
            )
          }
          size={"S"}
          variation={0}
          clearable={false}
        />
      </div>
      <div className={styles.selector}>
        <Combobox
          label="Period:"
          labelPosition={"TOP"}
          loading={fetchingFactribPeriods}
          value={factribPeriod}
          options={factribPeriodOptions}
          placeholder="Select Period..."
          onChange={(factribPeriod) =>
            setNewFa(
              new PivotFADefinition({
                factribFactor,
                factribPeriod,
              })
            )
          }
          gridHeight={100}
          size={"S"}
          variation={0}
          clearable={false}
        />
      </div>
    </div>
  );
};

MiniFaSelectorComplication.propTypes = {
  setNewFa: PropTypes.func.isRequired,
  faDefinition: PropTypes.object.isRequired,
};

export default MiniFaSelectorComplication;
